export const bonuses = [
  {
    number: 1,
    tint: "#FFF4CF",
    ink: "#7A5200",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/c70eab4e-5208-42c8-a56c-c50a6ecbf3a4.jpg",
    title: "Everyday Visual Communication Board Library™",
    value: "$19",
    subtitle: "Organize Visual Communication Resources for Real-Life Activities.",
    description: "A collection of sample communication board layouts and adaptable planning templates covering common everyday situations.",
    items: [
      "Mealtime communication board examples.",
      "Playtime communication layouts.",
      "Classroom participation board templates.",
      "Personal routine communication resources.",
      "Preference and choice communication organizers.",
      "Blank templates for individual adaptation.",
    ],
    why: "You’ll have practical visual examples to consult when preparing communication resources.",
  },
  {
    number: 2,
    tint: "#E4F6EB",
    ink: "#0B6B35",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/a4928de7-4a30-4c4f-8f42-f7e1d2e4be34.jpg",
    title: "Autism Visual Routine Toolkit™",
    value: "$17",
    subtitle: "Plan Visual Supports for Daily Activities and Transitions.",
    description: "A practical workbook for organizing visual routine supports based on individual preferences and environmental needs.",
    items: [
      "Morning routine planning templates.",
      "Classroom transition organizers.",
      "Daily activity sequence examples.",
      "Home routine visual planning sheets.",
      "Visual schedule adaptation checklists.",
      "Routine participation observation tools.",
    ],
    why: "It provides a structured starting point for planning visual routine resources.",
  },
  {
    number: 3,
    tint: "#FFEBD9",
    ink: "#9A4300",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/f9a9c6ea-95a0-4017-b6bc-aacda4d4da63.jpg",
    title: "Functional Communication Activity Workbook™",
    value: "$17",
    subtitle: "Organize Meaningful Communication Opportunities Through Everyday Activities.",
    description: "A practical workbook containing activity planning examples and communication opportunity worksheets.",
    items: [
      "Play-based communication activity organizers.",
      "Choice-making opportunity worksheets.",
      "Shared-interest interaction planning tools.",
      "Everyday communication function examples.",
      "Activity adaptation templates.",
      "Participation observation worksheets.",
    ],
    why: "It helps connect communication planning with practical, meaningful activities.",
  },
  {
    number: 4,
    tint: "#FDE6F0",
    ink: "#A3195B",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/9fc9e0f9-eed6-4606-b15f-610dcb911549.jpg",
    title: "Family & Educator Communication Partner Guide™",
    value: "$19",
    subtitle: "Make Communication Support Planning More Collaborative.",
    description: "A workbook designed to help organize conversations, shared priorities, and practical support strategies across environments.",
    items: [
      "Family communication discussion worksheets.",
      "Classroom collaboration templates.",
      "Communication partner reflection questions.",
      "Everyday interaction planning examples.",
      "Shared support strategy organizers.",
      "Collaborative follow-up templates.",
    ],
    why: "You’ll have structured materials for communicating planning priorities with the people involved in the child’s everyday life.",
  },
  {
    number: 5,
    tint: "#EFE7FC",
    ink: "#5B2DB3",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/f7a41d51-0f35-4988-b1da-0bc74124cec7.jpg",
    title: "Autism Communication Documentation Pack™",
    value: "$17",
    subtitle: "Keep Communication Planning, Observations & Follow-Up Organized.",
    description: "A collection of practical documentation templates designed to support consistent recordkeeping.",
    items: [
      "Communication observation logs.",
      "Individualized planning worksheets.",
      "Participation tracking templates.",
      "Environmental adjustment records.",
      "Family collaboration notes.",
      "Follow-up and next-step planning sheets.",
    ],
    why: "You can organize important planning information without creating every document from scratch.",
  },
];
